import { Pipe, PipeTransform, Injectable } from '@angular/core';

@Pipe({ name: 'weekColumnName' })
@Injectable({ providedIn: 'root' })
export class WeekColumnNamePipe implements PipeTransform {
    transform(obj: any): string {
        if (!obj) return '';

        const start = this.getStartDateOfISOWeek(obj.week, obj.year);
        const end = new Date(start);
        end.setDate(start.getDate() + 6);

        const startDay = start.getDate();
        const startMonth = start.getMonth() + 1;

        const endDay = end.getDate();
        const endMonth = end.getMonth() + 1;

        const shortYear = obj.year % 100;

        return `${startMonth}/${startDay}–${endMonth}/${endDay} ${shortYear}`;
    }

    private getStartDateOfISOWeek(week: number, year: number): Date {
        const simple = new Date(year, 0, 1 + (week - 1) * 7);
        const dow = simple.getDay();
        const ISOweekStart = new Date(simple.getTime());

        if (dow <= 4)
            ISOweekStart.setDate(simple.getDate() - simple.getDay() + 1);
        else ISOweekStart.setDate(simple.getDate() + 8 - simple.getDay());

        return ISOweekStart;
    }
}
